export default __webpack_public_path__ + "static/media/81.8deaa854.png";